import { Button } from '@app/shared/ui/button';
import { DialogContent, DialogClose } from '@app/shared/ui/dialog';
import { cvaIcon } from '@app/shared/ui/elements';

import { CrossIcon } from '@app/components/ui/icons';

import {
  cvaCardContainer,
  cvaGradientTop,
  cvaGradientBottom,
  cvaTitleContainer,
  cvaTitle,
  cvaSubtitle,
  cvaProgressContainer,
  cvaProgressBackground,
  cvaProgressFill,
  cvaHelpContainer,
  cvaHelpText,
  cvaContactButton,
} from './payments-payg-styles';

type PayAsYouGoCardProps = {
  downloaded?: number;
  total?: number;
  onContactSupport?: () => void;
};

export function PaymentsPayg({ downloaded = 0, total = 0, onContactSupport }: PayAsYouGoCardProps) {
  const raw = total > 0 ? 100 - (downloaded / total) * 100 : 0;
  const progressPercentage = Math.max(0, Math.min(100, raw));

  return (
    <DialogContent
      className="max-w-[31rem]"
      customCloseIcon={
        <DialogClose
          aria-label="Close"
          className="absolute right-2 top-2 transition-colors disabled:pointer-events-none text-general_text_MII_secondary_i hover:text-general_text_MII_default focus-visible:outline"
        >
          <CrossIcon className={cvaIcon()} />
          <span className="sr-only">Close</span>
        </DialogClose>
      }
    >
      <div className={cvaCardContainer()}>
        {/* Background gradients */}
        <div className={cvaGradientTop()}>
          <div className="absolute inset-[-23.256%]">
            <svg
              className="block size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 630 630"
            >
              <g filter="url(#filter0_f_top)" opacity="0.4">
                <circle cx="315" cy="315" fill="#219979" r="215" />
              </g>
              <defs>
                <filter
                  colorInterpolationFilters="sRGB"
                  filterUnits="userSpaceOnUse"
                  height="630"
                  id="filter0_f_top"
                  width="630"
                  x="0"
                  y="0"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="shape"
                  />
                  <feGaussianBlur result="effect1_foregroundBlur" stdDeviation="50" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>

        <div className={cvaGradientBottom()}>
          <div className="absolute inset-[-23.256%]">
            <svg
              className="block size-full"
              fill="none"
              preserveAspectRatio="none"
              viewBox="0 0 630 630"
            >
              <g filter="url(#filter0_f_bottom)" opacity="0.24">
                <circle cx="315" cy="315" fill="#219979" r="215" />
              </g>
              <defs>
                <filter
                  colorInterpolationFilters="sRGB"
                  filterUnits="userSpaceOnUse"
                  height="630"
                  id="filter0_f_bottom"
                  width="630"
                  x="0"
                  y="0"
                >
                  <feFlood floodOpacity="0" result="BackgroundImageFix" />
                  <feBlend
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    mode="normal"
                    result="shape"
                  />
                  <feGaussianBlur result="effect1_foregroundBlur" stdDeviation="50" />
                </filter>
              </defs>
            </svg>
          </div>
        </div>

        {/* Title */}
        <div className={cvaTitleContainer()}>
          <h2 className={cvaTitle()}>Pay as You Go</h2>
          <p className={cvaSubtitle()}>
            Downloaded {downloaded} of {total}
          </p>

          {/* Progress bar */}
          <div className={cvaProgressContainer()}>
            <div className={cvaProgressBackground()} />
            <div className={cvaProgressFill()} style={{ width: `${progressPercentage}%` }} />
          </div>
        </div>

        {/* Help section */}
        <div className={cvaHelpContainer()}>
          <p className={cvaHelpText()}>Any questions? Write to us</p>

          <a href="mailto:support@wonderslide.com" onClick={onContactSupport}>
            <Button
              variant="outline"
              size="semiMedium"
              className={cvaContactButton()}
              borderRadius="3xl"
            >
              support@wonderslide.com
            </Button>
          </a>
        </div>
      </div>
    </DialogContent>
  );
}
